var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQNav5NotSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-q-nav-5-not-selected{fill:#fff;}.cls-2-q-nav-5-not-selected{fill:#33b0ce;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-q-nav-5-not-selected",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-q-nav-5-not-selected",
    d: "M17,31A14,14,0,1,1,31,17,14,14,0,0,1,17,31ZM17,4A13,13,0,1,0,30,17,13,13,0,0,0,17,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-q-nav-5-not-selected",
    d: "M21.55,15.63a5.15,5.15,0,1,0,5.15,5.15A5.16,5.16,0,0,0,21.55,15.63Zm0,1.3a3.8,3.8,0,0,1,2,.58l-5.27,5.27a3.78,3.78,0,0,1-.58-2A3.86,3.86,0,0,1,21.55,16.93Zm0,7.7a3.84,3.84,0,0,1-2.41-.87l5.39-5.39a3.83,3.83,0,0,1-3,6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-q-nav-5-not-selected",
    d: "M17,17.49h0l3.45-4a3.57,3.57,0,1,0-5.39-4.69l-6.9,7.94a3.57,3.57,0,0,0,.35,5,3.56,3.56,0,0,0,2.34.88h.25a3.58,3.58,0,0,0,2.45-1.22l3.45-4Zm-1-7.8a2.25,2.25,0,0,1,1.56-.78h.16a2.22,2.22,0,0,1,1.48.55A2.25,2.25,0,0,1,20,11a2.27,2.27,0,0,1-.55,1.65l-3,3.48-3.45-3Zm-2.45,9.74h-.09l-4.79.43a2.29,2.29,0,0,1-.1-1l5.88-.41Zm-1.45-5.26,1,.83-1.8.13Zm-2,2.35,4.41-.31,1,.83h-.09l-6.1.43ZM11,21.38a2.2,2.2,0,0,1-1.31-.31l2.63-.24A2.21,2.21,0,0,1,11,21.38Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQNav5NotSelected);
export default __webpack_public_path__ + "static/media/q_nav_5_not_selected.530d42d3.svg";
export { ForwardRef as ReactComponent };